import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
import { MetadataSortByInfo } from '../../../assets-panel/collections/types/generated/MetadataSortByInfo.schema';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type ShareSortBys_AdHocAssetsShare_Fragment = { __typename?: 'AdHocAssetsShare', sortBys?: { __typename?: 'MetadataSortByConnection', totalCount: number, nodes: Array<{ __typename?: 'MetadataSortBy', id?: string | null, direction: Types.OrderDirectionEnum, fieldDefinition: { __typename?: 'ProjectFieldDefinition', fieldType: Types.FieldTypeEnum, id: string, isDefaultField?: boolean | null, isFilterable?: boolean | null, isGroupable?: boolean | null, isSortable?: boolean | null, isSystemField: boolean, name: string, configuration?: { __typename?: 'DateFieldConfiguration', displayFormat?: Types.DisplayFormatEnum | null, displayTimezone?: boolean | null, includeTime?: boolean | null, timeFormat?: Types.TimeFormatEnum | null } | { __typename?: 'NumberFieldConfiguration', scale?: number | null } | { __typename?: 'RatingFieldConfiguration', color?: string | null, maxValue: number, style?: Types.RatingStyleEnum | null } | { __typename?: 'SelectFieldConfiguration', options: Array<{ __typename?: 'SelectOption', color?: string | null, displayName: string, id: string }> } | { __typename?: 'ToggleFieldConfiguration', color?: string | null } | { __typename?: 'UserFieldConfiguration', memberOptionsType: Types.MemberOptionsTypeEnum, notifyMembers: boolean, customMembers?: Array<{ __typename?: 'CustomMember', id: string, type: Types.CustomMemberTypeEnum }> | null } | { __typename?: 'UsersFieldConfiguration', memberOptionsType: Types.MemberOptionsTypeEnum, notifyMembers: boolean, selectType: Types.MemberSelectTypeEnum, customMembers?: Array<{ __typename?: 'CustomMember', id: string, type: Types.CustomMemberTypeEnum }> | null } | null } }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } | null };

export type ShareSortBys_CollectionShare_Fragment = { __typename?: 'CollectionShare' };

export type ShareSortBysFragment = ShareSortBys_AdHocAssetsShare_Fragment | ShareSortBys_CollectionShare_Fragment;

export const ShareSortBys = /*#__PURE__*/ gql`
    fragment ShareSortBys on Share {
  ... on AdHocAssetsShare {
    sortBys(page: {first: 50}) {
      nodes {
        ...MetadataSortByInfo
      }
      pageInfo {
        endCursor
        hasNextPage
      }
      totalCount
    }
  }
}
    ${MetadataSortByInfo}` as unknown as DocumentNode<ShareSortBysFragment, unknown>;

        

        
export const useShareSortBysFragment = (
  input: string | Omit<UseFragmentOptions<ShareSortBysFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Share' } };
    return input;
  })();

  return useFragment<ShareSortBysFragment>({
    fragment: ShareSortBys,
    fragmentName: 'ShareSortBys',
    ...options,
  });
};
  
        